module.exports = __webpack_public_path__ + "static/media/press09.8dc77d86.png";